import { gql } from '@apollo/client';

export const GET_PICKUP_PROGRESS_NEW = gql`
  query GetPickupProgressNew($warehouseId: Long!, $taskDate: String) {
    getPickupProgressNew(warehouseId: $warehouseId, taskDate: $taskDate) {
      id
      warehouseId
      snapshotDate
      summary {
        tasks {
          total
          draft
          published
          inProgress
          completed
          cancelled
        }
        onTimeRate {
          appointments
          parcels
        }
        parcels {
          expected
          pickedUp
        }
      }
      tasks {
        taskId
        taskNumber
        driver
        driverPhoneNumber
        driverCountryCode
        vehicleNumber
        licensePlate
        expDepartureTime
        actDepartureTime
        appointmentOnTimeRate
        expectedParcel
        pickedUpParcel
        status
      }
      createdAt
      updatedAt
      lastUpdateAt
    }
  }
`;

export interface TaskSummaryType {
  total: number;
  draft: number;
  published: number;
  inProgress: number;
  completed: number;
  cancelled: number;
}

export interface OnTimeRateSummaryType {
  appointments: string;
  parcels: string;
}

export interface PickupParcelsSummaryType {
  expected: string;
  pickedUp: string;
}

export interface PickupProgressSummaryType {
  tasks: TaskSummaryType;
  onTimeRate: OnTimeRateSummaryType;
  parcels: PickupParcelsSummaryType;
}

export interface PickupTaskDetailType {
  taskId: string;
  taskNumber: string;
  driver?: string | null;
  driverPhoneNumber?: string | null;
  driverCountryCode?: string | null;
  vehicleNumber?: string | null;
  licensePlate?: string | null;
  expDepartureTime: string;
  actDepartureTime: string;
  appointmentOnTimeRate: string;
  expectedParcel: string;
  pickedUpParcel: string;
  status: string;
}

export interface PickupProgressSnapshotResultType {
  id: string;
  warehouseId: string;
  snapshotDate: string;
  summary: PickupProgressSummaryType;
  tasks: PickupTaskDetailType[];
  createdAt?: string | null;
  updatedAt?: string | null;
  lastUpdateAt?: string | null;
}

export interface GetPickupProgressNewResponse {
  getPickupProgressNew: PickupProgressSnapshotResultType | null;
}
